import { ReactElement } from 'react';

import { PrintTemplateClickRegisterCommand } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { useGetCurrentPractitionerGlobalState } from '~libs.shared.account';

type PrintTemplateClickRegisterParameters = Readonly<{
   printTemplateId: PrintTemplateClickRegisterCommand['id'];
   printTemplateName: PrintTemplateClickRegisterCommand['printTemplateName'];
}>;

type PrintTemplateClickRegisterActionChildrenRenderProps = Readonly<{
   registerClick: (parameters: PrintTemplateClickRegisterParameters) => Promise<void>;
}>;

type PrintTemplateClickRegisterActionProps = Readonly<{
   children: (renderProps: PrintTemplateClickRegisterActionChildrenRenderProps) => ReactElement;
}>;

export const PrintTemplateClickRegisterAction = (props: PrintTemplateClickRegisterActionProps): JSX.Element => {
   const currentPractitioner = useGetCurrentPractitionerGlobalState();

   const { executeAsync: registerClick } = useCqrsCommand<void, PrintTemplateClickRegisterParameters>((parameters) => {
      const command = new PrintTemplateClickRegisterCommand();
      command.id = parameters.printTemplateId;
      command.printTemplateName = parameters.printTemplateName;
      command.specialtyNames = currentPractitioner.doctorSpecialties.map(
         (specialty) => specialty.medicalSpecialty.name
      );
      return command;
   });

   return props.children({ registerClick: registerClick });
};
